import api from '../api/api';

/**
 * Get current user's profile information
 * @returns {Promise} - Promise that resolves to user profile data
 */
export const getUserProfile = async () => {
  try {
    const response = await api.get('/settings/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Update user profile information
 * @param {Object} profileData - User profile data to update
 * @returns {Promise} - Promise that resolves to updated user profile
 */
export const updateUserProfile = async (profileData) => {
  try {
    const response = await api.put('/settings/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

/**
 * Change user password
 * @param {Object} passwordData - Object containing currentPassword and newPassword
 * @returns {Promise} - Promise that resolves to API response
 */
export const changePassword = async (passwordData) => {
  try {
    const response = await api.post('/settings/change-password', passwordData);
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};

/**
 * Upload profile picture
 * @param {File} imageFile - Image file to upload
 * @returns {Promise} - Promise that resolves to uploaded image URL
 */
export const uploadProfilePicture = async (imageFile) => {
  try {
    const formData = new FormData();
    formData.append('profileImage', imageFile);
    
    const response = await api.post('/users/upload-profile-picture', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error uploading profile picture:', error);
    throw error;
  }
};

const userService = {
  getUserProfile,
  updateUserProfile,
  changePassword,
  uploadProfilePicture
};

export default userService;